// removed by extract-text-webpack-plugin
module.exports = {"container-iframe":"index__container-iframe--3GdiA","drawer":"index__drawer--4HJ6-","icon-close":"index__icon-close--1omVR","iframe-content":"index__iframe-content--3_lV9","toolbar":"index__toolbar--2MxDy","icon-toolbar":"index__icon-toolbar--347qs"};


//////////////////
// WEBPACK FOOTER
// ./src/client/shared-components/GlobalDocumentation/styles/index.scss
// module id = G29G
// module chunks = 23